export default "__VITE_ASSET__BKgxsFd2__"